module.exports = __webpack_public_path__ + "img/hashicon3.a3650ab9.svg";